import axios from "axios";
import { Notify, Toast } from "vant";
import { getCookie, delCookie } from "../utils/cookies";
import vueI18n from '../utils/i18n';
import { baseUrl, port } from "./config";
import errCode from "./err"
import CryptoJS from "crypto-js";
export default function request(method, url, data , str) {
  let header =  {headers: {}}
  if(str){  //产生交易添加密文
    header.headers['X-WC-Webhook-HPTSign'] = CryptoJS.MD5(str).toString()
  }
  url = baseUrl + url;
  method = method.toLocaleLowerCase();
  let formData = new FormData();
  for (let i in data) {
    formData.append(i, data[i]);
  }
  if (method === "post") {
    return axios.post(url, formData,header);
  } else if (method === "postjson") {
    return axios.post(url, data, {
      headers: { "Content-Type": "application/json" }
    });
  } else if (method === "get") {
    return axios.get(url, {
      params: data,
    },header);
  } else if (method === "delete") {
    return axios.delete(url, {
      params: data
    },header); 
  } else if (method === "put") {
    return axios.put(url, formData,header);
  } 
  else if(method === 'posthead'){
    // 提交JSON数据方式
    return axios.post(url,formData,header)
  } 
}

axios.interceptors.request.use(
  config => {
    Toast.loading({
      message: "Loading...",
      forbidClick: true,
      loadingType: "spinner"
    });
    if (config.url !== baseUrl + "cms/async/getData") {
      config.timeout = 30 * 1000; // 设置请求响应时间
    }
    
    if (getCookie("token")) {
      const len = baseUrl.length;
      config.headers = {
        ... config.headers,
        "Content-Type": "application/json",
        Authorization: getCookie("token"),
        "X-Server-Host": CryptoJS.MD5(
          `${baseUrl.slice(0, len - 1)}${port}`
        ).toString()
      };
      
    } else {
      config.headers = {
        ... config.headers,
        "Content-Type": "application/json"
      };
    }
    // const len = host.length
    // console.log(`${ host.slice(0, len - 1) }${ port }`)
    // headers['X-Server-Host'] = CryptoJS.MD5(`${ host }${ port }`).toString()
    // headers['X-Server-Host'] = CryptoJS.MD5(`${ host.slice(0, len - 1) }${ port }`).toString()

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// 响应请求拦截
axios.interceptors.response.use(
  response => {
    Toast.clear();
    if (response.data.code === 200) {
      return Promise.resolve(response.data);
    } else {
      const code = response.data.code;
      // Notify({ type: 'danger', message: vueI18n.t(`tag.${code}`) })
      if (errCode.hasOwnProperty(code)) {
        Notify({ type: "danger", message: errCode[code] });
      } else {
        Notify({ type: "danger", message: code });
      }
    }
    return Promise.resolve(response.data);
  },
  err => {
    Toast.clear();
    if (err && err.response) {
      switch (err.response.status) {
        case 404:
          break;
        case 401:
          console.log("权限认证失败");
          // Notify({ type: 'danger', message: vueI18n.t(`tag.${err.response.status}`) })
          Notify({ type: "danger", message: "401" });
          window.localStorage.clear();
          // delCookie('token')
          // location.reload()
          break;
        case 500:
          // Notify({ type: 'danger', message: vueI18n.t(`tag.${err.response.status}`) })
          Notify({ type: "danger", message: "500" });
          console.log("服务器错误");
          break;
        default:
          // Notify({ type: 'danger', message: vueI18n.t(`tag.${err.response.status}`) })
          Notify({ type: "danger", message: "链接错误" });
          console.log(`连接错误${err.response.status}`);
      }
    } else {
      // Notify({ type: 'danger', message: vueI18n.t(`tag.serveError`) })
      Notify({ type: "danger", message: "serveError" });
    }
    // Toast.clear()
    return Promise.reject(err);
  }
);
// 二次封装axios

// export default function request(method, url, params) {
//   // RequestBody
//   url = baseUrl + url;
//   method = method.toLocaleLowerCase();
//   let formData = new FormData();
//   for (let i in params) {
//     formData.append(i, params[i])
//   }
//   //封装RESTful API的各种请求方式
//   if (method === 'post') {
//     return axios.post(url, formData) //axios的post 默认转化为json格式
//   } else if (method === 'postjson') {
//     return axios.post(url, params,{headers: {'Content-Type': 'application/json'}})
//   }else if (method === 'get') {
//     return axios.get(url, {
//       params: params
//     })
//   } else if (method === 'delete') {
//     return axios.delete(url, {
//       params: params
//     })
//   }else if(method === 'putjson'){
//     // 提交JSON数据方式
//     return axios.put(url, params,{headers: {'Content-Type': 'application/json'}})
//   } else if (method === 'put') {
//     return axios.put(url, formData)
//   }
// }
